(function () {
  if (window.ImedRepairCatalog?.cacheVersion === 'v57-1') return;

  const REPAIR_SUFFIXES = [
    'Diagnose & Kostenvoranschlag',
    'Kostenvoranschlag / Diagnose',
    'Diagnose / Kostenvoranschlag',
    'Controller Stick-Drift Reparatur',
    'Joy-Con Stick-Drift Reparatur',
    'Controller Akku Reparatur',
    'HDMI Buchse Reparatur',
    'HDMI Port Reparatur',
    'Optical Drive Reparatur',
    'Disc Drive Reparatur',
    'Blu-ray Drive Reparatur',
    'Power Supply Reparatur',
    'Kamera (auch Kameraglas) Reparatur',
    'Glasreparatur (reiner Glasbruch)',
    'Glas Display Reparatur',
    'Displayreparatur (Soft-OLED Nachbau)',
    'Displayreparatur (Premium Refurbished)',
    'Displayreparatur (Apple Original)',
    'TrueDepth (FaceID) Reparatur',
    'Stick-Drift Reparatur',
    'Mittelrahmen Reparatur',
    'Rückseite Reparatur',
    'Backcover Reparatur',
    'Gehäuse Reparatur',
    'Ladebuchse Reparatur',
    'Ladebuchsen Reparatur',
    'Controller Reparatur',
    'Joy-Con Reparatur',
    'Netzteil Reparatur',
    'Lüfter Reparatur',
    'Display Reparatur',
    'Kamera Reparatur',
    'Mikrofon Reparatur',
    'Microfon Reparatur',
    'Akku Reparatur',
    'Lüfter Reinigung',
    'Displayreparatur',
    'Folie (original)',
    'Elektronik-Check',
    'Reifenwechsel (8.5 Zoll)',
    'Vollgummireifen Montage',
    'Bremsbeläge Wechsel',
    'Wasserschadenbehandlung',
    'Gashebel Reparatur',
    'Bremsen Reparatur',
    'Reifen Reparatur',
    'Akkureparatur',
    'Glasreparatur',
    'Kamerareparatur',
    'Ladebuchsenreparatur',
    'Rückglasreparatur',
    ' Glas',
  ];

  const GENERIC_REPAIR_PATTERNS = [
    /^(?<model>.+?)\s+(?<repair>.+\sReparatur)$/iu,
    /^(?<model>.+?)\s+(?<repair>.+\sReinigung)$/iu,
    /^(?<model>.+?)\s+(?<repair>.+\sWechsel)$/iu,
    /^(?<model>.+?)\s+(?<repair>.+\sMontage)$/iu,
    /^(?<model>.+?)\s+(?<repair>Elektronik-Check)$/iu,
    /^(?<model>.+?)\s+(?<repair>Wasserschadenbehandlung)$/iu,
  ];

  const REPAIR_SUFFIXES_SORTED = [...REPAIR_SUFFIXES].sort((a, b) => b.length - a.length);

  const REPAIR_ALIASES = {
    Akkureparatur: 'Akku Reparatur',
    Kamerareparatur: 'Kamera Reparatur',
    Ladebuchsenreparatur: 'Ladebuchse Reparatur',
    'Ladebuchsen Reparatur': 'Ladebuchse Reparatur',
    Rückglasreparatur: 'Rückglas Reparatur',
    'Gashebel Reparatur': 'Gashebel',
    'Bremsen Reparatur': 'Bremsen',
    'Reifen Reparatur': 'Reifen',
    'Controller Reparatur': 'Controller',
    'Diagnose & Kostenvoranschlag': 'Diagnose',
    'Diagnose / Kostenvoranschlag': 'Diagnose',
    'Kostenvoranschlag / Diagnose': 'Diagnose',
    Wartung: 'Wartung',
  };

  const BRAND_ONLY_MODELS = new Set([
    'google',
    'samsung',
    'apple',
    'xiaomi',
    'oneplus',
    'huawei',
    'sony',
    'motorola',
    'nokia',
    'fairphone',
  ]);

  const BAD_MODEL_PATTERN =
    / Reparatur$|Mittelrahmen|TrueDepth|Wasserschadenbehandlung|Akkureparatur|\bGlas$|\bDisplay$/i;

  const CACHE_VERSION = 'v58-1';
  const FRESH_TTL_MS = 45 * 60 * 1000;
  const CONSOLE_FRESH_TTL_MS = 8 * 60 * 1000;
  const STALE_TTL_MS = 24 * 60 * 60 * 1000;
  const SESSION_PREFIX = `imed-col-${CACHE_VERSION}-`;
  const AVAILABILITY_PREFIX = `imed-col-available-${CACHE_VERSION}-`;
  const AVAILABILITY_TTL_MS = 30 * 60 * 1000;

  const SMARTPHONE_COLLECTION_HINT = /smartphone/i;
  const SMARTPHONE_EXCLUDE_PATTERN =
    /\bplaystation\b|\bps5\b|\bps4\b|\bxbox\b|\bnintendo\b|\bswitch\b|\bsteam deck\b|\bgalaxy tab\b|\bipad\b|\bmacbook\b|\bwatch\b|\bsmartwatch\b|\bthermomix\b|\bninebot\b|\be-scooter\b|\bescooter\b|\bcontroller\b|\bsurface laptop\b|\bthinkpad\b|\bideapad\b|\bthinkbook\b|\blatitude\b|\binspiron\b|\bprecision\b|\bxps\b|\bzenbook\b|\bvivobook\b|\bexpertbook\b|\belitebook\b|\bprobook\b|\bspectre\b|\bpavilion\b/i;

  const cache = new Map();
  const inflight = new Map();
  const inflightCallbacks = new Map();
  const availabilityInflight = new Map();

  function isConsoleHandle(handle) {
    return /konsol|console/i.test(handle || '');
  }

  function getFreshTtl(handle) {
    return isConsoleHandle(handle) ? CONSOLE_FRESH_TTL_MS : FRESH_TTL_MS;
  }

  function normalizeRepairLabel(repair) {
    return REPAIR_ALIASES[repair] || repair;
  }

  function normalizeModelName(model) {
    let normalized = model.trim();
    const orphanSuffixes = [' Glas', ' Display', ' Akku', ' Kamera'];
    for (const suffix of orphanSuffixes) {
      if (normalized.endsWith(suffix)) {
        normalized = normalized.slice(0, -suffix.length).trim();
      }
    }
    return canonicalModelKey(normalized);
  }

  function canonicalModelKey(model) {
    let normalized = model.trim().replace(/\s+/g, ' ');

    normalized = normalized.replace(/\s5G\b/gi, '');
    normalized = normalized.replace(/\s*\(\d{4}\)\s*$/g, '');
    normalized = normalized.replace(/\+\s*Plus\b/gi, '+ (Plus)');

    normalized = normalized.replace(/\bmini\b/gi, 'mini');
    normalized = normalized.replace(/\bmax\b/gi, 'Max');
    normalized = normalized.replace(/\bplus\b/gi, 'Plus');
    normalized = normalized.replace(/\bultra\b/gi, 'Ultra');
    normalized = normalized.replace(/\bpro\b/gi, 'Pro');
    normalized = normalized.replace(/\bair\b/gi, 'Air');
    normalized = normalized.replace(/\bfe\b/gi, 'FE');

    normalized = normalized.replace(/^iPhone iPhone /i, 'iPhone ');
    normalized = normalized.replace(/^iPhone SE 3 \(2022\)$/i, 'iPhone SE (3. Generation)');
    normalized = normalized.replace(/^iPhone SE 3$/i, 'iPhone SE (3. Generation)');
    normalized = normalized.replace(/^iPhone SE2$/i, 'iPhone SE (2. Generation)');
    normalized = normalized.replace(/^iPhone SE 2$/i, 'iPhone SE (2. Generation)');

    return normalized.replace(/\s+/g, ' ').trim();
  }

  function getUniqueModelNames(modelNames) {
    const seen = new Map();

    modelNames.forEach((name) => {
      const canonical = canonicalModelKey(name);
      const dedupeKey = canonical.toLowerCase();
      if (!seen.has(dedupeKey)) {
        seen.set(dedupeKey, canonical);
      }
    });

    return [...seen.values()];
  }

  function splitTitleIntoModelAndRepair(title) {
    const trimmed = title.trim();

    for (const suffix of REPAIR_SUFFIXES_SORTED) {
      if (trimmed.endsWith(suffix)) {
        return {
          model: normalizeModelName(trimmed.slice(0, trimmed.length - suffix.length)),
          repair: normalizeRepairLabel(suffix.trim()),
        };
      }
    }

    if (/\b(scooter|kickscooter|kqi|soflow|egret)\b/i.test(trimmed) && trimmed.endsWith(' Wartung')) {
      return {
        model: normalizeModelName(trimmed.slice(0, -' Wartung'.length)),
        repair: normalizeRepairLabel('Wartung'),
      };
    }

    for (const pattern of GENERIC_REPAIR_PATTERNS) {
      const match = trimmed.match(pattern);
      if (match?.groups?.model && match?.groups?.repair) {
        return {
          model: normalizeModelName(match.groups.model.trim()),
          repair: normalizeRepairLabel(match.groups.repair.trim()),
        };
      }
    }

    const legacyPatterns = [
      /^(?<model>.+)\s+(?<repair>.+\sReparatur\s\(.+\))$/,
      /^(?<model>.+?)(?<repair>Akkureparatur|Displayreparatur|Glasreparatur|Kamerareparatur|Ladebuchsenreparatur|Rückglasreparatur|Backcoverreparatur)$/iu,
    ];

    for (const pattern of legacyPatterns) {
      const match = trimmed.match(pattern);
      if (match?.groups?.model && match?.groups?.repair) {
        return {
          model: normalizeModelName(match.groups.model.trim()),
          repair: normalizeRepairLabel(match.groups.repair.trim()),
        };
      }
    }

    return { model: normalizeModelName(trimmed), repair: 'Sonstige Reparatur' };
  }

  function mergeCatalogModels(catalog) {
    Object.values(catalog).forEach((brandModels) => {
      const merged = {};

      Object.entries(brandModels).forEach(([modelName, products]) => {
        const canonical = canonicalModelKey(modelName);
        const dedupeKey = canonical.toLowerCase();
        const existingKey = Object.keys(merged).find(
          (key) => canonicalModelKey(key).toLowerCase() === dedupeKey
        );

        if (existingKey) {
          merged[existingKey].push(...products);
        } else {
          merged[canonical] = [...products];
        }
      });

      Object.keys(brandModels).forEach((key) => delete brandModels[key]);
      Object.assign(brandModels, merged);
    });

    return catalog;
  }

  function isEscooterProduct(product) {
    const tags = Array.isArray(product.tags)
      ? product.tags.join(' ').toLowerCase()
      : String(product.tags || '').toLowerCase();
    const type = (product.product_type || '').toLowerCase();
    const title = (product.title || '').toLowerCase();
    const vendor = (product.vendor || '').toLowerCase();
    const blob = `${title} ${type} ${tags} ${vendor}`;
    return (
      tags.includes('e-scooter') ||
      tags.includes('reparaturen für e-scooter') ||
      type.includes('scooter') ||
      type.includes('kickscooter') ||
      type.includes('kqi') ||
      /\bkickscooter\b|\belectric scooter\b|\bmi scooter\b|\bsoflow\b|\begret\b|\bvmax\b|\bninebot\b|\bsegway\b|\bkqi\b/.test(
        blob
      ) ||
      vendor.includes('ninebot') ||
      vendor.includes('segway') ||
      vendor.includes('niu') ||
      vendor.includes('soflow') ||
      vendor.includes('egret') ||
      vendor.includes('vmax') ||
      (vendor === 'xiaomi' && /\bscooter\b/.test(title))
    );
  }

  function isConsoleProduct(product) {
    if (isEscooterProduct(product)) return false;
    const blob = `${product.title || ''} ${product.product_type || ''} ${getProductTagsText(product)} ${
      product.vendor || ''
    }`.toLowerCase();
    return /playstation|\bps[45]\b|xbox|nintendo|switch|steam\s*deck|dualsense|joy-?con|konsolen/.test(blob);
  }

  function normalizeEscooterBrand(vendor) {
    const value = (vendor || 'Sonstige').trim();
    if (/segway|ninebot/i.test(value)) return 'Ninebot';
    return value;
  }

  function parseEscooterProduct(product) {
    const modelFromType = (product.product_type || '').trim();
    const title = (product.title || '').trim();
    const model = modelFromType || normalizeModelName(title);
    let repair = 'Sonstige Reparatur';

    const suffixes = [
      'Diagnose / Kostenvoranschlag',
      'Kostenvoranschlag / Diagnose',
      'Controller Reparatur',
      'Gashebel Reparatur',
      'Bremsen Reparatur',
      'Reifen Reparatur',
      'Wartung',
    ].sort((a, b) => b.length - a.length);

    for (const suffix of suffixes) {
      const needle = ` ${suffix}`;
      if (title === `${model} ${suffix}` || title.endsWith(needle)) {
        repair = normalizeRepairLabel(suffix);
        break;
      }
    }

    return {
      ...product,
      parsedModel: model,
      parsedRepair: repair,
      parsedBrand: normalizeEscooterBrand(product.vendor),
    };
  }

  function getProductTagsText(product) {
    return Array.isArray(product.tags)
      ? product.tags.join(' ')
      : String(product.tags || '');
  }

  function hasConsoleCollectionTag(product) {
    return /reparaturen\s+f(?:ü|u|ue)r\s+konsolen/i.test(getProductTagsText(product));
  }

  function parseStructuredConsoleProduct(product) {
    const title = (product.title || '').trim();
    const model = canonicalModelKey((product.product_type || '').trim());
    const titleLower = title.toLocaleLowerCase('de');
    const modelLower = model.toLocaleLowerCase('de');
    const modelIndex = titleLower.indexOf(modelLower);
    let repair = '';

    if (modelIndex >= 0) {
      repair = title.slice(modelIndex + model.length).trim();
    }

    if (!repair) {
      repair = splitTitleIntoModelAndRepair(title).repair;
    }

    return {
      ...product,
      parsedModel: model,
      parsedRepair: normalizeRepairLabel(repair || 'Sonstige Reparatur'),
      parsedBrand: (product.vendor || 'Sonstige').trim(),
    };
  }

  function parseStructuredServiceProduct(product) {
    const title = (product.title || '').trim();
    const model = canonicalModelKey((product.product_type || '').trim());
    let repair = '';

    if (model && title.toLocaleLowerCase('de').startsWith(model.toLocaleLowerCase('de'))) {
      repair = title.slice(model.length).trim();
    }
    if (!repair) repair = splitTitleIntoModelAndRepair(title).repair;
    if (/diagnose|kostenvoranschlag/i.test(title)) repair = 'Diagnose';

    return {
      ...product,
      parsedModel: model || splitTitleIntoModelAndRepair(title).model,
      parsedRepair: normalizeRepairLabel(repair || 'Sonstige Reparatur'),
      parsedBrand: (product.vendor || 'Sonstige').trim(),
    };
  }

  function parseProduct(product) {
    if (isEscooterProduct(product)) {
      return parseEscooterProduct(product);
    }

    if (hasConsoleCollectionTag(product) && (product.product_type || '').trim()) {
      return parseStructuredConsoleProduct(product);
    }

    if (
      (product.product_type || '').trim() &&
      /Reparaturen für (?:Laptops \/ MacBooks|Smartwatches|Thermomix®)/.test(getProductTagsText(product))
    ) {
      return parseStructuredServiceProduct(product);
    }

    const { model, repair } = splitTitleIntoModelAndRepair(product.title);
    const brand = (product.vendor || 'Sonstige').trim();
    return { ...product, parsedModel: model, parsedRepair: repair, parsedBrand: brand };
  }

  function buildCatalog(products) {
    const brands = {};

    products.map((p) => parseProduct(p)).forEach((product) => {
      if (!brands[product.parsedBrand]) brands[product.parsedBrand] = {};
      if (!brands[product.parsedBrand][product.parsedModel]) {
        brands[product.parsedBrand][product.parsedModel] = [];
      }
      brands[product.parsedBrand][product.parsedModel].push(product);
    });

    return mergeCatalogModels(brands);
  }

  function filterModelNames(models) {
    return models.filter((model) => {
      if (BAD_MODEL_PATTERN.test(model)) return false;
      if (BRAND_ONLY_MODELS.has(model.trim().toLowerCase())) return false;
      return true;
    });
  }

  const CANONICAL_CATEGORY_BY_HANDLE = {
    'reparaturen-fur-smartphones': 'Reparaturen für Smartphones',
    'reparaturen-fur-konsolen': 'Reparaturen für Konsolen',
    'reparaturen-fur-smartwatch': 'Reparaturen für Smartwatches',
    'reparaturen-fur-smartwatches': 'Reparaturen für Smartwatches',
    'reparaturen-fur-laptops': 'Reparaturen für Laptops / MacBooks',
    'reparaturen-fur-thermomix': 'Reparaturen für Thermomix®',
    'reparaturen-fur-escooter': 'Reparaturen für E-Scooter',
    'reparaturen-fur-e-scooter': 'Reparaturen für E-Scooter',
  };

  const CATEGORY_TAG_PATTERN = /^Reparaturen für (?:Smartphones|Konsolen|Smartwatches|Laptops \/ MacBooks|Thermomix®|E-Scooter)$/;

  function matchesLegacyCollection(product, handle) {
    const title = (product.title || '').toLowerCase();
    const type = (product.product_type || '').toLowerCase();
    const vendor = (product.vendor || '').toLowerCase();
    const blob = `${title} ${type}`;

    if (isEscooterProduct(product)) {
      return handle.includes('scooter');
    }

    if (handle.includes('smartphone')) {
      if (SMARTPHONE_EXCLUDE_PATTERN.test(blob)) return false;
      return vendor !== 'sony' || /\bxperia\b/.test(blob);
    }
    if (handle.includes('konsol')) return isConsoleProduct(product);
    if (handle.includes('smartwatch')) return /watch|smartwatch/.test(blob);
    if (handle.includes('laptop')) return /macbook|surface|thinkpad|ideapad|zenbook|vivobook|latitude|xps|inspiron|elitebook|probook|spectre|envy|laptop/.test(blob);
    if (handle.includes('thermomix')) return /thermomix|\btm[567]\b/.test(blob) || vendor === 'vorwerk';
    if (handle.includes('scooter')) return false;
    return true;
  }

  function shouldIncludeInCollection(product, collectionHandle) {
    const handle = (collectionHandle || '').toLowerCase();
    const expectedCategory = CANONICAL_CATEGORY_BY_HANDLE[handle];
    const scooter = isEscooterProduct(product);

    // Hard split: scooters never appear under Konsolen/Smartphones/etc.
    if (handle.includes('scooter') || expectedCategory === 'Reparaturen für E-Scooter') {
      return scooter;
    }
    if (scooter) return false;

    if (!expectedCategory) {
      return matchesLegacyCollection(product, handle);
    }

    // Konsolen: content wins over a wrong exclusive category tag on scooter leftovers.
    if (handle.includes('konsol') || expectedCategory === 'Reparaturen für Konsolen') {
      return isConsoleProduct(product);
    }

    const productTags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
    const categoryTags = productTags.map((tag) => String(tag).trim()).filter((tag) => CATEGORY_TAG_PATTERN.test(tag));
    if (categoryTags.length) {
      return categoryTags.length === 1 && categoryTags[0] === expectedCategory && matchesLegacyCollection(product, handle);
    }

    return matchesLegacyCollection(product, handle);
  }

  function filterCollectionProducts(products, collectionHandle) {
    return products.filter((product) => shouldIncludeInCollection(product, collectionHandle));
  }

  function getCacheEntry(handle) {
    return cache.get(handle) || null;
  }

  function setCacheEntry(handle, products, complete, timestamp = Date.now()) {
    cache.set(handle, {
      products: [...products],
      complete: Boolean(complete),
      ts: timestamp,
    });
    if (complete) {
      writeSessionCache(handle, products, timestamp);
    }
  }

  function clearCacheEntry(handle) {
    cache.delete(handle);
    try {
      sessionStorage.removeItem(`${SESSION_PREFIX}${handle}`);
    } catch {
      // ignore
    }
  }

  function readSessionCache(handle) {
    try {
      const raw = sessionStorage.getItem(`${SESSION_PREFIX}${handle}`);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (Date.now() - parsed.ts > STALE_TTL_MS) {
        sessionStorage.removeItem(`${SESSION_PREFIX}${handle}`);
        return null;
      }
      if (!parsed.complete || !Array.isArray(parsed.products) || !parsed.products.length) {
        sessionStorage.removeItem(`${SESSION_PREFIX}${handle}`);
        return null;
      }
      return { products: parsed.products, ts: parsed.ts };
    } catch {
      return null;
    }
  }

  function writeSessionCache(handle, products, timestamp = Date.now()) {
    try {
      sessionStorage.setItem(
        `${SESSION_PREFIX}${handle}`,
        JSON.stringify({ ts: timestamp, products, complete: true })
      );
    } catch {
      // sessionStorage quota – ignore
    }
  }

  async function fetchCollectionPage(handle, page) {
    const response = await fetch(`/collections/${handle}/products.json?limit=250&page=${page}`);
    if (!response.ok) throw new Error(`Collection ${handle} failed (${response.status})`);
    const data = await response.json();
    return data.products || [];
  }

  async function fetchCollectionInternal(handle) {
    const products = [];
    const preserveCompleteCache = Boolean(getCacheEntry(handle)?.complete);
    const page1 = await fetchCollectionPage(handle, 1);
    products.push(...filterCollectionProducts(page1, handle));
    const page1Complete = page1.length < 250;
    if (page1Complete || !preserveCompleteCache) {
      setCacheEntry(handle, products, page1Complete);
    }
    notifyInflightCallbacks(handle, products, page1Complete);

    if (page1.length >= 250) {
      let page = 2;
      while (page <= 20) {
        const batch = await fetchCollectionPage(handle, page);
        if (!batch.length) break;
        products.push(...filterCollectionProducts(batch, handle));
        const complete = batch.length < 250;
        if (complete || !preserveCompleteCache) {
          setCacheEntry(handle, products, complete);
        }
        notifyInflightCallbacks(handle, products, complete);
        if (complete) break;
        page += 1;
      }
    }

    setCacheEntry(handle, products, true);
    notifyInflightCallbacks(handle, products, true);
    return products;
  }

  function notifyInflightCallbacks(handle, products, complete) {
    const callbacks = inflightCallbacks.get(handle) || [];
    callbacks.forEach((cb) => {
      try {
        cb(products, complete);
      } catch (error) {
        console.error('Collection update callback failed', error);
      }
    });
    if (complete) inflightCallbacks.delete(handle);
  }

  async function refreshCollection(handle) {
    clearCacheEntry(handle);
    return startNetworkLoad(handle);
  }

  function attachInflightCallback(handle, onUpdate) {
    if (!onUpdate) return;
    const existing = inflightCallbacks.get(handle) || new Set();
    existing.add(onUpdate);
    inflightCallbacks.set(handle, existing);
  }

  function startNetworkLoad(handle) {
    if (inflight.has(handle)) return inflight.get(handle);

    const promise = fetchCollectionInternal(handle).finally(() => {
      inflight.delete(handle);
      inflightCallbacks.delete(handle);
    });
    inflight.set(handle, promise);
    return promise;
  }

  async function fetchCollection(handle, options = {}) {
    let cached = getCacheEntry(handle);
    if (cached && Date.now() - cached.ts > STALE_TTL_MS) {
      clearCacheEntry(handle);
      cached = null;
    }

    if (cached?.complete) {
      options.onUpdate?.(cached.products, true);
      if (Date.now() - cached.ts > getFreshTtl(handle) || options.revalidate) {
        attachInflightCallback(handle, options.onUpdate);
        startNetworkLoad(handle).catch((error) => {
          console.warn(`Collection refresh failed for ${handle}`, error);
        });
      }
      return cached.products;
    }

    if (inflight.has(handle)) {
      attachInflightCallback(handle, options.onUpdate);
      if (cached?.products?.length) {
        options.onUpdate?.(cached.products, false);
      }
      return inflight.get(handle);
    }

    const sessionEntry = readSessionCache(handle);
    if (sessionEntry?.products?.length) {
      setCacheEntry(handle, sessionEntry.products, true, sessionEntry.ts);
      options.onUpdate?.(sessionEntry.products, true);
      if (Date.now() - sessionEntry.ts > getFreshTtl(handle) || options.revalidate) {
        attachInflightCallback(handle, options.onUpdate);
        startNetworkLoad(handle).catch((error) => {
          console.warn(`Collection refresh failed for ${handle}`, error);
        });
      }
      return sessionEntry.products;
    }

    attachInflightCallback(handle, options.onUpdate);
    return startNetworkLoad(handle);
  }

  function prefetchCollections(handles = []) {
    const unique = [...new Set(handles.filter(Boolean))];
    const run = () => {
      unique.forEach((handle) => {
        const cached = getCacheEntry(handle);
        if (!cached?.complete && !readSessionCache(handle) && !inflight.has(handle)) {
          fetchCollection(handle).catch(() => {});
        }
      });
    };

    if ('requestIdleCallback' in window) {
      requestIdleCallback(run, { timeout: 900 });
    } else {
      setTimeout(run, 400);
    }
  }

  async function hideEmptyCategoryButtons(root, selector, options = {}) {
    const revalidate = options.revalidate === true;
    const buttons = [...root.querySelectorAll(selector)];
    const grid = root.querySelector('.imed-konfigurator__grid, .imed-finder-grid');

    buttons.forEach((btn) => {
      const cached = readAvailability(btn.dataset.collectionHandle);
      btn.hidden = cached?.hasProducts === false;
      btn.disabled = false;
    });
    grid?.classList.remove('is-loading-categories');

    // Soft check only when explicitly requested (e.g. after finder opens).
    // Never force-revalidate every category on page load — that hammered collections.
    if (!revalidate) return;

    const refresh = () =>
      Promise.all(
        buttons.map(async (btn) => {
          const handle = btn.dataset.collectionHandle;
          if (!handle) return;

          const cached = readAvailability(handle);
          if (cached && Date.now() - cached.ts < AVAILABILITY_TTL_MS) {
            btn.hidden = !cached.hasProducts;
            return;
          }

          const hasProducts = await collectionHasProducts(handle, false);
          btn.hidden = !hasProducts;
        })
      ).catch((error) => console.warn('Category availability refresh failed', error));

    if ('requestIdleCallback' in window) {
      requestIdleCallback(refresh, { timeout: 2500 });
    } else {
      setTimeout(refresh, 1000);
    }
  }

  function readAvailability(handle) {
    if (!handle) return null;
    try {
      const parsed = JSON.parse(localStorage.getItem(`${AVAILABILITY_PREFIX}${handle}`));
      if (!parsed || Date.now() - parsed.ts > AVAILABILITY_TTL_MS) return null;
      return parsed;
    } catch {
      return null;
    }
  }

  function writeAvailability(handle, hasProducts) {
    try {
      localStorage.setItem(
        `${AVAILABILITY_PREFIX}${handle}`,
        JSON.stringify({ ts: Date.now(), hasProducts })
      );
    } catch {
      // localStorage quota/privacy mode – ignore
    }
  }

  async function collectionHasProducts(handle, revalidate = false) {
    const cached = readAvailability(handle);
    if (cached && !revalidate) return cached.hasProducts;
    if (availabilityInflight.has(handle)) return availabilityInflight.get(handle);

    const request = (async () => {
      try {
        const res = await fetch(`/collections/${handle}/products.json?limit=1`);
        if (!res.ok) return cached?.hasProducts ?? true;
        const data = await res.json();
        const hasProducts = Boolean(data.products?.length);
        writeAvailability(handle, hasProducts);
        return hasProducts;
      } catch {
        return cached?.hasProducts ?? true;
      }
    })().finally(() => availabilityInflight.delete(handle));

    availabilityInflight.set(handle, request);
    return request;
  }

  function formatMoney(price) {
    const amount = parseFloat(price);
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(amount);
  }

  function getLowestVariantPrice(product) {
    const variants = product.variants.filter((v) => v.available !== false);
    if (!variants.length) return null;
    return Math.min(...variants.map((v) => parseFloat(v.price)));
  }

  function getUsableVariants(product) {
    // Kein Fallback auf ausverkaufte Varianten — sonst erscheinen „nicht verfügbar“-Reparaturen weiter im Finder
    return product.variants.filter((v) => v.available !== false);
  }

  function variantOptionValue(variant, position) {
    if (position === 1) return variant.option1;
    if (position === 2) return variant.option2;
    if (position === 3) return variant.option3;
    return null;
  }

  function isMeaningfulOptionValue(value) {
    if (!value) return false;
    const norm = String(value).trim().toLowerCase();
    return norm !== 'default title';
  }

  function resolveProductOptions(product) {
    const options = product.options || [];
    const typeOption =
      options.find((option) => /reparaturtyp|repair type|typ/i.test(option.name || '')) ||
      options[0] ||
      null;
    const colorOption = options.find((option) => /farbe|color/i.test(option.name || '')) || null;

    return {
      typePosition: typeOption?.position || 1,
      colorPosition: colorOption?.position || 2,
      typeLabel: typeOption?.name || 'Reparaturtyp',
      colorLabel: colorOption?.name || 'Farbe',
      hasColorOption: Boolean(colorOption),
    };
  }

  function analyzeVariantPicker(product) {
    const usable = getUsableVariants(product);
    if (!usable.length) {
      return { mode: 'none', usable: [] };
    }
    if (usable.length === 1) {
      return { mode: 'none', usable, variant: usable[0] };
    }

    const optionMeta = resolveProductOptions(product);
    const { typePosition, colorPosition, typeLabel, colorLabel, hasColorOption } = optionMeta;
    const hasColors =
      hasColorOption &&
      usable.some((variant) => isMeaningfulOptionValue(variantOptionValue(variant, colorPosition)));

    const entriesByType = new Map();
    usable.forEach((variant) => {
      const typeValue = variantOptionValue(variant, typePosition) || variant.title;
      const colorValue = variantOptionValue(variant, colorPosition);
      if (!entriesByType.has(typeValue)) entriesByType.set(typeValue, []);
      entriesByType.get(typeValue).push({
        color: isMeaningfulOptionValue(colorValue) ? colorValue : null,
        variant,
      });
    });

    const types = [...entriesByType.keys()];

    if (types.length > 1 && hasColors) {
      return {
        mode: 'tiered',
        usable,
        typeLabel,
        colorLabel,
        typePosition,
        colorPosition,
        types,
        entriesByType,
      };
    }

    if (types.length > 1 && !hasColors) {
      return {
        mode: 'type',
        usable,
        typeLabel,
        typePosition,
        types,
        entriesByType,
      };
    }

    return { mode: 'flat', usable, typeLabel, colorLabel };
  }

  class VariantPickerUI {
    constructor({ elements, onVariantChange }) {
      this.els = elements;
      this.onVariantChange = onVariantChange;
      this.product = null;
      this.analysis = null;

      this.els.typeSelect?.addEventListener('change', () => this.handleTypeChange());
      this.els.colorSelect?.addEventListener('change', () => this.handleColorChange());
      this.els.flatSelect?.addEventListener('change', () => this.handleFlatChange());
    }

    reset() {
      this.resetUI();
      this.product = null;
      this.analysis = null;
    }

    resetUI() {
      if (this.els.wrap) {
        this.els.wrap.hidden = true;
        this.els.wrap.style.display = 'none';
      }
      if (this.els.tierWrap) {
        this.els.tierWrap.hidden = true;
        this.els.tierWrap.style.display = 'none';
      }
      if (this.els.flatWrap) {
        this.els.flatWrap.hidden = true;
        this.els.flatWrap.style.display = 'none';
      }
      if (this.els.colorField) {
        this.els.colorField.hidden = true;
        this.els.colorField.style.display = 'none';
      }
      if (this.els.typeSelect) this.els.typeSelect.innerHTML = '';
      if (this.els.colorSelect) this.els.colorSelect.innerHTML = '';
      if (this.els.flatSelect) this.els.flatSelect.innerHTML = '';
    }

    showWrap() {
      if (!this.els.wrap) return;
      this.els.wrap.hidden = false;
      this.els.wrap.style.display = '';
    }

    populateColorOptions(typeValue) {
      const select = this.els.colorSelect;
      if (!select) return null;

      select.innerHTML = '';
      const entries = this.analysis?.entriesByType?.get(typeValue) || [];
      const seen = new Set();

      entries.forEach(({ color, variant }) => {
        if (!color || seen.has(color)) return;
        seen.add(color);
        const opt = document.createElement('option');
        opt.value = String(variant.id);
        opt.textContent = `${color} – ${formatMoney(variant.price)}`;
        select.appendChild(opt);
      });

      if (!select.options.length && entries.length) {
        const variant = entries[0].variant;
        const opt = document.createElement('option');
        opt.value = String(variant.id);
        opt.textContent = formatMoney(variant.price);
        select.appendChild(opt);
      }

      return this.findVariantById(select.value);
    }

    findVariantById(variantId) {
      if (!this.product || variantId == null || variantId === '') return null;
      return this.product.variants.find((variant) => String(variant.id) === String(variantId)) || null;
    }

    emitVariant(variant) {
      if (!variant) return null;
      this.onVariantChange?.(variant);
      return variant;
    }

    handleTypeChange() {
      if (!this.product || !this.analysis) return;
      const typeValue = this.els.typeSelect?.value;
      if (!typeValue) return;

      if (this.analysis.mode === 'tiered') {
        if (this.els.colorField) {
          this.els.colorField.hidden = false;
          this.els.colorField.style.display = '';
        }
        const variant = this.populateColorOptions(typeValue);
        this.emitVariant(variant);
        return;
      }

      if (this.analysis.mode === 'type') {
        const entries = this.analysis.entriesByType.get(typeValue) || [];
        this.emitVariant(entries[0]?.variant || null);
      }
    }

    handleColorChange() {
      if (!this.product) return;
      this.emitVariant(this.findVariantById(this.els.colorSelect?.value));
    }

    handleFlatChange() {
      if (!this.product) return;
      this.emitVariant(this.findVariantById(this.els.flatSelect?.value));
    }

    render(product) {
      this.resetUI();
      this.product = product;
      this.analysis = analyzeVariantPicker(product);

      if (this.analysis.mode === 'none') {
        const variant = this.analysis.variant || this.analysis.usable[0] || null;
        this.emitVariant(variant);
        return variant;
      }

      this.showWrap();

      if (this.analysis.mode === 'flat') {
        if (this.els.flatWrap) {
          this.els.flatWrap.hidden = false;
          this.els.flatWrap.style.display = '';
        }
        this.analysis.usable.forEach((variant) => {
          const opt = document.createElement('option');
          opt.value = String(variant.id);
          opt.textContent = `${variant.title} – ${formatMoney(variant.price)}`;
          this.els.flatSelect?.appendChild(opt);
        });
        const variant = this.analysis.usable[0];
        if (this.els.flatSelect) this.els.flatSelect.value = String(variant.id);
        this.emitVariant(variant);
        return variant;
      }

      if (this.els.tierWrap) {
        this.els.tierWrap.hidden = false;
        this.els.tierWrap.style.display = '';
      }
      if (this.els.typeLabel) {
        this.els.typeLabel.textContent = this.analysis.typeLabel;
      }
      if (this.els.colorLabel && this.analysis.colorLabel) {
        this.els.colorLabel.textContent = this.analysis.colorLabel;
      }

      this.analysis.types.forEach((typeValue) => {
        const entries = this.analysis.entriesByType.get(typeValue) || [];
        const variant = entries[0]?.variant;
        if (!variant) return;

        const opt = document.createElement('option');
        opt.value = typeValue;
        opt.textContent =
          this.analysis.mode === 'type'
            ? `${typeValue} – ${formatMoney(variant.price)}`
            : typeValue;
        this.els.typeSelect?.appendChild(opt);
      });

      if (this.els.typeSelect && this.analysis.types.length) {
        this.els.typeSelect.value = this.analysis.types[0];
      }

      if (this.analysis.mode === 'tiered') {
        const variant = this.populateColorOptions(this.analysis.types[0]);
        if (this.els.colorField) {
          this.els.colorField.hidden = false;
          this.els.colorField.style.display = '';
        }
        this.emitVariant(variant);
        return variant;
      }

      const entries = this.analysis.entriesByType.get(this.analysis.types[0]) || [];
      const variant = entries[0]?.variant || null;
      this.emitVariant(variant);
      return variant;
    }
  }

  const PLACEHOLDER_BY_HANDLE = {
    'reparaturen-fur-smartphones': 'smartphone',
    'reparaturen-fuer-smartphones': 'smartphone',
    'reparaturen-fur-tablets': 'tablet',
    'reparaturen-fuer-tablets': 'tablet',
    'reparaturen-fur-laptops': 'laptop',
    'reparaturen-fuer-laptops': 'laptop',
    'reparaturen-fur-konsolen': 'console',
    'reparaturen-fuer-konsolen': 'console',
    'reparaturen-fur-thermomix': 'thermomix',
    'reparaturen-fuer-thermomix': 'thermomix',
    'reparaturen-fur-e-scooter': 'escooter',
    'reparaturen-fuer-e-scooter': 'escooter',
    'reparaturen-fur-escooter': 'escooter',
    'reparaturen-fuer-escooter': 'escooter',
    'reparaturen-fur-smartwatches': 'smartwatch',
    'reparaturen-fuer-smartwatches': 'smartwatch',
  };

  function detectPlaceholderCategory(product, collectionHandle) {
    const handle = (collectionHandle || '').toLowerCase();
    if (PLACEHOLDER_BY_HANDLE[handle]) return PLACEHOLDER_BY_HANDLE[handle];

    const title = (product.title || '').toLowerCase();
    const tags = (product.tags || []).join(',').toLowerCase();
    const type = (product.product_type || '').toLowerCase();
    const vendor = (product.vendor || '').toLowerCase();

    if (handle.includes('tablet') || tags.includes('tablet') || title.includes('ipad') || title.includes('galaxy tab')) {
      return 'tablet';
    }
    if (handle.includes('smartwatch') || title.includes('watch') || tags.includes('smartwatch')) {
      return 'smartwatch';
    }
    if (
      handle.includes('laptop') ||
      handle.includes('macbook') ||
      title.includes('macbook') ||
      /surface|thinkpad|ideapad|thinkbook|latitude|inspiron|precision|\bxps\b|zenbook|vivobook|expertbook|elitebook|probook|spectre|pavilion/.test(title) ||
      /surface|thinkpad|latitude|zenbook|elitebook|laptop/.test(type)
    ) {
      return 'laptop';
    }
    if (handle.includes('konsolen') || title.includes('playstation') || title.includes('xbox')) {
      return 'console';
    }
    if (handle.includes('thermomix') || title.includes('thermomix') || vendor.includes('vorwerk')) {
      return 'thermomix';
    }
    if (handle.includes('scooter') || title.includes('scooter') || title.includes('ninebot')) {
      return 'escooter';
    }
    if (
      handle.includes('smartphone') ||
      title.includes('iphone') ||
      title.includes('galaxy s') ||
      title.includes('pixel') ||
      type.includes('phone')
    ) {
      return 'smartphone';
    }

    return 'default';
  }

  const PLACEHOLDER_IMAGE_HASH = '362cc4fa-28d8-439e-a6fe-4cba8d52e382';

  const BRAND_COLORS = {
    apple: '#1d1d1f',
    samsung: '#1428a0',
    google: '#4285f4',
    xiaomi: '#ff6900',
    oneplus: '#eb0028',
    huawei: '#cf0a2c',
    oppo: '#1a7842',
    motorola: '#005eb8',
    sony: '#000000',
    xbox: '#107c10',
    microsoft: '#737373',
    lenovo: '#e2231a',
    dell: '#0672ce',
    asus: '#00539b',
    hp: '#0096d6',
    nintendo: '#e60012',
    vorwerk: '#00a550',
    default: '#6e6e73',
  };

  const CATEGORY_LABELS = {
    tablet: 'Tablet',
    smartwatch: 'Smartwatch',
    laptop: 'Laptop',
    console: "<svg class=\"imed-device-render imed-device-render--console\" viewBox=\"0 0 220 320\" fill=\"none\"><g> <path class=\"device-shadow\" d=\"M34 102c12-29 39-38 76-20 37-18 64-9 76 20l20 83c8 34-27 48-45 20l-22-31H81l-22 31c-18 28-53 14-45-20z\"/> <path class=\"device-body\" d=\"M29 96c12-29 39-38 76-20 37-18 64-9 76 20l20 83c8 34-27 48-45 20l-22-31H76l-22 31c-18 28-53 14-45-20z\"/> <circle class=\"device-control\" cx=\"70\" cy=\"122\" r=\"18\"/><circle class=\"device-control\" cx=\"147\" cy=\"142\" r=\"18\"/> <path class=\"device-dpad\" d=\"M49 150h14v-14h14v14h14v14H77v14H63v-14H49z\"/> <circle class=\"device-button\" cx=\"168\" cy=\"107\" r=\"6\"/><circle class=\"device-button\" cx=\"184\" cy=\"122\" r=\"6\"/> <circle class=\"device-button\" cx=\"152\" cy=\"122\" r=\"6\"/><circle class=\"device-button\" cx=\"168\" cy=\"138\" r=\"6\"/> </g></svg>",
    thermomix: 'Thermomix',
    smartphone: 'Smartphone',
    default: 'Reparatur',
  };

  const REPAIR_ICONS = {
    display:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="6" y="8" width="20" height="16" rx="2" stroke="currentColor" stroke-width="2.4"/><path d="M10 12h12M10 16h8" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    battery:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="10" width="16" height="12" rx="2" stroke="currentColor" stroke-width="2.4"/><path d="M24 14v4" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><path d="M12 14v4M16 14v4" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    camera:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="7" stroke="currentColor" stroke-width="2.4"/><circle cx="16" cy="16" r="3" fill="currentColor"/><path d="M11 10h4l1.5-2h5L23 10h3v14H8V10h3z" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round"/></svg>',
    back:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="10" y="6" width="12" height="20" rx="3" stroke="currentColor" stroke-width="2.4"/><circle cx="16" cy="14" r="3" stroke="currentColor" stroke-width="2.4"/></svg>',
    charging:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6l-6 10h5l-2 10 8-12h-5l2-8z" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round"/></svg>',
    diagnose:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="14" cy="14" r="7" stroke="currentColor" stroke-width="2.4"/><path d="M19 19l6.5 6.5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    scale:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7 11h18l-2 14H9L7 11z" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round"/><path d="M12 16a4 4 0 018 0" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><path d="M16 16l2-2" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    lock:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="14" width="16" height="12" rx="2" stroke="currentColor" stroke-width="2.4"/><path d="M12 14v-3a4 4 0 018 0v3M16 19v3" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    heat:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 7c-3 4 3 5 0 9s3 5 0 9M18 7c-3 4 3 5 0 9s3 5 0 9" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/><path d="M24 10v13" stroke="currentColor" stroke-width="2.4"/><circle cx="24" cy="25" r="3" stroke="currentColor" stroke-width="2.4"/></svg>',
    motor:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="16" r="10" stroke="currentColor" stroke-width="2.4"/><circle cx="16" cy="16" r="3" stroke="currentColor" stroke-width="2.4"/><path d="M16 6v5M16 21v5M6 16h5M21 16h5" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    water:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 6c4 6 8 10 8 14a8 8 0 11-16 0c0-4 4-8 8-14z" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round"/></svg>',
    audio:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 12H8v8h4l6 4V8l-6 4z" stroke="currentColor" stroke-width="2.4" stroke-linejoin="round"/><path d="M22 12a4 4 0 010 8M24 10a7 7 0 010 12" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
    glass:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="8" y="8" width="16" height="16" rx="2" stroke="currentColor" stroke-width="2.4"/><path d="M8 8l16 16" stroke="currentColor" stroke-width="2.4"/></svg>',
    repair:
      '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 14l6-6 6 6" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"/><path d="M16 8v14M8 24h16" stroke="currentColor" stroke-width="2.4" stroke-linecap="round"/></svg>',
  };

  const DEVICE_SILHOUETTES = {
    'iphone-air':
      '<svg class="imed-device-render imed-device-render--iphone-air" viewBox="0 0 220 320" fill="none"><g transform="rotate(-5 110 160)"><rect class="device-shadow" x="51" y="20" width="124" height="280" rx="33"/><rect class="device-body" x="46" y="14" width="124" height="280" rx="33"/><rect class="device-edge" x="51" y="19" width="114" height="270" rx="28"/><rect class="device-camera-deck" x="60" y="31" width="48" height="48" rx="17"/><circle class="device-lens-ring" cx="84" cy="55" r="17"/><circle class="device-lens" cx="84" cy="55" r="12"/><circle class="device-flash" cx="124" cy="51" r="7"/><circle class="device-sensor" cx="124" cy="70" r="5"/></g><g class="device-front-preview" transform="rotate(4 110 160)"><rect class="device-screen-body" x="119" y="58" width="62" height="218" rx="23"/><rect class="device-screen" x="124" y="64" width="52" height="206" rx="18"/><rect class="device-island" x="136" y="72" width="29" height="10" rx="5"/></g></svg>',
    'iphone-17-pro':
      '<svg class="imed-device-render imed-device-render--iphone-17-pro" viewBox="0 0 220 320" fill="none"><g transform="rotate(-4 110 160)"><rect class="device-shadow" x="44" y="18" width="138" height="284" rx="34"/><rect class="device-body" x="39" y="12" width="138" height="284" rx="34"/><rect class="device-edge" x="45" y="18" width="126" height="272" rx="29"/><rect class="device-camera-deck" x="49" y="26" width="92" height="96" rx="26"/><rect class="device-camera-glass" x="56" y="33" width="78" height="82" rx="20"/><circle class="device-lens-ring" cx="78" cy="54" r="19"/><circle class="device-lens" cx="78" cy="54" r="13"/><circle class="device-lens-ring" cx="114" cy="72" r="19"/><circle class="device-lens" cx="114" cy="72" r="13"/><circle class="device-lens-ring" cx="78" cy="96" r="19"/><circle class="device-lens" cx="78" cy="96" r="13"/><circle class="device-flash" cx="118" cy="42" r="7"/><circle class="device-sensor" cx="118" cy="104" r="5"/><circle class="device-sensor" cx="105" cy="48" r="3"/></g><g class="device-front-preview" transform="rotate(5 110 160)"><rect class="device-screen-body" x="108" y="52" width="78" height="224" rx="26"/><rect class="device-screen" x="114" y="59" width="66" height="210" rx="21"/><rect class="device-island" x="128" y="68" width="38" height="12" rx="6"/><circle class="device-sensor" cx="158" cy="74" r="2.5"/></g></svg>',
    'iphone-16-pro':
      '<svg class="imed-device-render imed-device-render--iphone-16-pro" viewBox="0 0 220 320" fill="none"><g transform="rotate(-5 110 160)"><rect class="device-shadow" x="47" y="22" width="132" height="276" rx="31"/><rect class="device-body" x="42" y="16" width="132" height="276" rx="31"/><rect class="device-edge" x="48" y="22" width="120" height="264" rx="26"/><rect class="device-camera-deck" x="55" y="33" width="72" height="76" rx="22"/><circle class="device-lens-ring" cx="76" cy="55" r="16"/><circle class="device-lens" cx="76" cy="55" r="11"/><circle class="device-lens-ring" cx="105" cy="69" r="16"/><circle class="device-lens" cx="105" cy="69" r="11"/><circle class="device-lens-ring" cx="76" cy="88" r="16"/><circle class="device-lens" cx="76" cy="88" r="11"/><circle class="device-flash" cx="108" cy="45" r="7"/><circle class="device-sensor" cx="111" cy="94" r="5"/></g><g class="device-front-preview" transform="rotate(5 110 160)"><rect class="device-screen-body" x="106" y="52" width="78" height="224" rx="24"/><rect class="device-screen" x="112" y="59" width="66" height="210" rx="19"/><rect class="device-island" x="129" y="68" width="34" height="11" rx="6"/></g></svg>',
    'iphone-15':
      '<svg class="imed-device-render imed-device-render--iphone-15" viewBox="0 0 220 320" fill="none"><g transform="rotate(-4 110 160)"><rect class="device-shadow" x="48" y="24" width="132" height="272" rx="31"/><rect class="device-body" x="43" y="18" width="132" height="272" rx="31"/><rect class="device-edge" x="49" y="24" width="120" height="260" rx="26"/><rect class="device-camera-deck" x="56" y="35" width="62" height="65" rx="20"/><circle class="device-lens-ring" cx="75" cy="55" r="16"/><circle class="device-lens" cx="75" cy="55" r="11"/><circle class="device-lens-ring" cx="99" cy="80" r="16"/><circle class="device-lens" cx="99" cy="80" r="11"/><circle class="device-flash" cx="101" cy="51" r="6"/></g><g class="device-front-preview" transform="rotate(4 110 160)"><rect class="device-screen-body" x="112" y="56" width="72" height="216" rx="23"/><rect class="device-screen" x="117" y="62" width="62" height="204" rx="18"/><rect class="device-island" x="131" y="70" width="34" height="10" rx="5"/></g></svg>',
    'iphone-14':
      '<svg class="imed-device-render imed-device-render--iphone-14" viewBox="0 0 220 320" fill="none"><g transform="rotate(-3 110 160)"><rect class="device-shadow" x="48" y="24" width="132" height="272" rx="29"/><rect class="device-body" x="43" y="18" width="132" height="272" rx="29"/><rect class="device-edge" x="49" y="24" width="120" height="260" rx="24"/><rect class="device-camera-deck" x="56" y="35" width="62" height="65" rx="18"/><circle class="device-lens-ring" cx="75" cy="55" r="16"/><circle class="device-lens" cx="75" cy="55" r="11"/><circle class="device-lens-ring" cx="99" cy="80" r="16"/><circle class="device-lens" cx="99" cy="80" r="11"/><circle class="device-flash" cx="101" cy="51" r="6"/></g><g class="device-front-preview" transform="rotate(4 110 160)"><rect class="device-screen-body" x="112" y="56" width="72" height="216" rx="22"/><rect class="device-screen" x="117" y="62" width="62" height="204" rx="17"/><path class="device-notch" d="M130 62h36v6c0 6-5 11-11 11h-14c-6 0-11-5-11-11V62z"/></g></svg>',
    'iphone-legacy':
      "<svg class=\"imed-device-render imed-device-render--iphone-legacy\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-3 110 160)\"> <rect class=\"device-shadow\" x=\"50\" y=\"25\" width=\"126\" height=\"270\" rx=\"27\"/> <rect class=\"device-body\" x=\"45\" y=\"19\" width=\"126\" height=\"270\" rx=\"27\"/> <rect class=\"device-edge\" x=\"51\" y=\"25\" width=\"114\" height=\"258\" rx=\"22\"/> <circle class=\"device-lens-ring\" cx=\"68\" cy=\"45\" r=\"13\"/><circle class=\"device-lens\" cx=\"68\" cy=\"45\" r=\"9\"/> <circle class=\"device-flash\" cx=\"88\" cy=\"45\" r=\"5\"/> <path class=\"device-logo\" d=\"M108 168c8-9 19-7 23-3-11 7-9 21 2 26-4 13-11 23-21 23-6 0-9-4-16-4-6 0-10 4-16 4-9 0-20-15-20-30 0-14 9-23 20-23 6 0 12 5 16 5 3 0 8-5 12-7z\"/> </g> <g class=\"device-front-preview\" transform=\"rotate(4 110 160)\"> <rect class=\"device-screen-body\" x=\"112\" y=\"56\" width=\"72\" height=\"216\" rx=\"18\"/> <rect class=\"device-screen\" x=\"117\" y=\"72\" width=\"62\" height=\"170\" rx=\"4\"/> <circle class=\"device-home\" cx=\"148\" cy=\"256\" r=\"8\"/> <rect class=\"device-notch\" x=\"130\" y=\"62\" width=\"36\" height=\"8\" rx=\"2\"/> </g></svg>",
    'galaxy-s-ultra':
      "<svg class=\"imed-device-render imed-device-render--galaxy-s-ultra\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-2 110 160)\"> <rect class=\"device-shadow\" x=\"43\" y=\"17\" width=\"136\" height=\"282\" rx=\"15\"/> <rect class=\"device-body\" x=\"38\" y=\"11\" width=\"136\" height=\"282\" rx=\"15\"/> <path class=\"device-edge\" d=\"M48 18h116c3 0 5 2 5 5v258c0 3-2 5-5 5H48c-3 0-5-2-5-5V23c0-3 2-5 5-5z\"/> <circle class=\"device-lens-ring\" cx=\"66\" cy=\"48\" r=\"18\"/><circle class=\"device-lens\" cx=\"66\" cy=\"48\" r=\"12\"/> <circle class=\"device-lens-ring\" cx=\"66\" cy=\"90\" r=\"18\"/><circle class=\"device-lens\" cx=\"66\" cy=\"90\" r=\"12\"/> <circle class=\"device-lens-ring\" cx=\"66\" cy=\"132\" r=\"18\"/><circle class=\"device-lens\" cx=\"66\" cy=\"132\" r=\"12\"/> <circle class=\"device-lens-ring device-lens-ring--small\" cx=\"106\" cy=\"65\" r=\"11\"/><circle class=\"device-lens\" cx=\"106\" cy=\"65\" r=\"7\"/> <circle class=\"device-lens-ring device-lens-ring--small\" cx=\"106\" cy=\"108\" r=\"11\"/><circle class=\"device-lens\" cx=\"106\" cy=\"108\" r=\"7\"/> <circle class=\"device-flash\" cx=\"107\" cy=\"88\" r=\"5\"/> <text class=\"device-wordmark\" x=\"74\" y=\"255\">SAMSUNG</text> </g> <g class=\"device-pen\" transform=\"rotate(-7 186 173)\"> <rect x=\"181\" y=\"66\" width=\"9\" height=\"219\" rx=\"4.5\"/><rect x=\"180\" y=\"58\" width=\"11\" height=\"13\" rx=\"3\"/> <path d=\"M181 285h9l-4.5 13z\"/> </g> <g class=\"device-front-preview\" transform=\"rotate(5 110 160)\"> <rect class=\"device-screen-body\" x=\"108\" y=\"52\" width=\"78\" height=\"224\" rx=\"18\"/> <rect class=\"device-screen\" x=\"113\" y=\"58\" width=\"68\" height=\"212\" rx=\"14\"/> <circle class=\"device-punch\" cx=\"147\" cy=\"72\" r=\"4\"/> </g></svg>",
    'galaxy-s':
      "<svg class=\"imed-device-render imed-device-render--galaxy-s\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-3 110 160)\"> <rect class=\"device-shadow\" x=\"48\" y=\"18\" width=\"130\" height=\"278\" rx=\"28\"/> <rect class=\"device-body\" x=\"43\" y=\"12\" width=\"130\" height=\"278\" rx=\"28\"/> <circle class=\"device-lens-ring\" cx=\"68\" cy=\"48\" r=\"16\"/><circle class=\"device-lens\" cx=\"68\" cy=\"48\" r=\"11\"/> <circle class=\"device-lens-ring\" cx=\"68\" cy=\"87\" r=\"16\"/><circle class=\"device-lens\" cx=\"68\" cy=\"87\" r=\"11\"/> <circle class=\"device-lens-ring\" cx=\"68\" cy=\"126\" r=\"16\"/><circle class=\"device-lens\" cx=\"68\" cy=\"126\" r=\"11\"/> <circle class=\"device-flash\" cx=\"98\" cy=\"88\" r=\"6\"/> <text class=\"device-wordmark\" x=\"72\" y=\"252\">SAMSUNG</text> </g> <g class=\"device-front-preview\" transform=\"rotate(4 110 160)\"> <rect class=\"device-screen-body\" x=\"112\" y=\"54\" width=\"72\" height=\"220\" rx=\"24\"/> <rect class=\"device-screen\" x=\"117\" y=\"60\" width=\"62\" height=\"208\" rx=\"19\"/> <circle class=\"device-punch\" cx=\"148\" cy=\"72\" r=\"4\"/> </g></svg>",
    'galaxy-z-fold':
      "<svg class=\"imed-device-render imed-device-render--galaxy-z-fold\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-2 110 160)\"> <rect class=\"device-shadow\" x=\"22\" y=\"49\" width=\"178\" height=\"222\" rx=\"21\"/> <rect class=\"device-body\" x=\"17\" y=\"43\" width=\"178\" height=\"222\" rx=\"21\"/> <rect class=\"device-screen\" x=\"25\" y=\"51\" width=\"162\" height=\"206\" rx=\"15\"/> <path class=\"device-fold\" d=\"M106 49v210\"/> <circle class=\"device-selfie\" cx=\"156\" cy=\"62\" r=\"4\"/> <rect class=\"device-camera-deck device-camera-deck--slim\" x=\"28\" y=\"61\" width=\"35\" height=\"93\" rx=\"14\"/> <circle class=\"device-lens\" cx=\"45\" cy=\"80\" r=\"10\"/><circle class=\"device-lens\" cx=\"45\" cy=\"108\" r=\"10\"/><circle class=\"device-lens\" cx=\"45\" cy=\"136\" r=\"10\"/> </g></svg>",
    'galaxy-z-flip':
      "<svg class=\"imed-device-render imed-device-render--galaxy-z-flip\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-4 110 160)\"> <rect class=\"device-shadow\" x=\"52\" y=\"19\" width=\"124\" height=\"280\" rx=\"31\"/> <rect class=\"device-body\" x=\"47\" y=\"13\" width=\"124\" height=\"280\" rx=\"31\"/> <path class=\"device-fold\" d=\"M50 158h118\"/> <rect class=\"device-cover-screen\" x=\"60\" y=\"29\" width=\"78\" height=\"62\" rx=\"15\"/> <circle class=\"device-lens-ring\" cx=\"71\" cy=\"110\" r=\"13\"/><circle class=\"device-lens\" cx=\"71\" cy=\"110\" r=\"9\"/> <circle class=\"device-lens-ring\" cx=\"103\" cy=\"110\" r=\"13\"/><circle class=\"device-lens\" cx=\"103\" cy=\"110\" r=\"9\"/> </g></svg>",
    'galaxy-a':
      "<svg class=\"imed-device-render imed-device-render--galaxy-a\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-3 110 160)\"> <rect class=\"device-shadow\" x=\"48\" y=\"18\" width=\"130\" height=\"278\" rx=\"28\"/> <rect class=\"device-body\" x=\"43\" y=\"12\" width=\"130\" height=\"278\" rx=\"28\"/> <rect class=\"device-camera-deck device-camera-deck--slim\" x=\"54\" y=\"30\" width=\"42\" height=\"106\" rx=\"18\"/> <circle class=\"device-lens-ring\" cx=\"75\" cy=\"49\" r=\"13\"/><circle class=\"device-lens\" cx=\"75\" cy=\"49\" r=\"9\"/> <circle class=\"device-lens-ring\" cx=\"75\" cy=\"80\" r=\"13\"/><circle class=\"device-lens\" cx=\"75\" cy=\"80\" r=\"9\"/> <circle class=\"device-lens-ring\" cx=\"75\" cy=\"111\" r=\"13\"/><circle class=\"device-lens\" cx=\"75\" cy=\"111\" r=\"9\"/> <circle class=\"device-flash\" cx=\"111\" cy=\"64\" r=\"6\"/> <text class=\"device-wordmark\" x=\"72\" y=\"252\">SAMSUNG</text> </g> <g class=\"device-front-preview\" transform=\"rotate(4 110 160)\"> <rect class=\"device-screen-body\" x=\"112\" y=\"54\" width=\"72\" height=\"220\" rx=\"24\"/> <rect class=\"device-screen\" x=\"117\" y=\"60\" width=\"62\" height=\"208\" rx=\"19\"/> <circle class=\"device-punch\" cx=\"148\" cy=\"72\" r=\"3.5\"/> </g></svg>",
    'pixel-bar':
      "<svg class=\"imed-device-render imed-device-render--pixel-bar\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-4 110 160)\"> <rect class=\"device-shadow\" x=\"46\" y=\"20\" width=\"136\" height=\"278\" rx=\"34\"/> <rect class=\"device-body\" x=\"41\" y=\"14\" width=\"136\" height=\"278\" rx=\"34\"/> <rect class=\"device-camera-bar\" x=\"48\" y=\"42\" width=\"122\" height=\"58\" rx=\"29\"/> <rect class=\"device-camera-glass\" x=\"58\" y=\"52\" width=\"82\" height=\"38\" rx=\"19\"/> <circle class=\"device-lens\" cx=\"78\" cy=\"71\" r=\"12\"/><circle class=\"device-lens\" cx=\"108\" cy=\"71\" r=\"12\"/> <rect class=\"device-lens device-lens--tele\" x=\"124\" y=\"60\" width=\"14\" height=\"22\" rx=\"5\"/> <circle class=\"device-flash\" cx=\"153\" cy=\"66\" r=\"7\"/><circle class=\"device-sensor\" cx=\"154\" cy=\"84\" r=\"6\"/> <text class=\"device-g-mark\" x=\"89\" y=\"205\">G</text> </g> <g class=\"device-front-preview\" transform=\"rotate(4 110 160)\"> <rect class=\"device-screen-body\" x=\"112\" y=\"54\" width=\"72\" height=\"220\" rx=\"26\"/> <rect class=\"device-screen\" x=\"117\" y=\"60\" width=\"62\" height=\"208\" rx=\"21\"/> <circle class=\"device-punch\" cx=\"148\" cy=\"72\" r=\"4\"/> </g></svg>",
    'pixel-fold':
      "<svg class=\"imed-device-render imed-device-render--pixel-fold\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-2 110 160)\"> <rect class=\"device-shadow\" x=\"22\" y=\"50\" width=\"178\" height=\"220\" rx=\"25\"/> <rect class=\"device-body\" x=\"17\" y=\"44\" width=\"178\" height=\"220\" rx=\"25\"/> <rect class=\"device-screen\" x=\"25\" y=\"52\" width=\"162\" height=\"204\" rx=\"18\"/> <path class=\"device-fold\" d=\"M106 50v208\"/> <rect class=\"device-camera-bar\" x=\"52\" y=\"63\" width=\"110\" height=\"39\" rx=\"20\"/> <circle class=\"device-lens\" cx=\"76\" cy=\"82\" r=\"9\"/><circle class=\"device-lens\" cx=\"102\" cy=\"82\" r=\"9\"/><circle class=\"device-lens\" cx=\"128\" cy=\"82\" r=\"9\"/> </g></svg>",
    'oneplus-nord':
      '<svg class="imed-device-render imed-device-render--oneplus-nord" viewBox="0 0 220 320" fill="none"><g transform="rotate(-4 110 160)"><rect class="device-shadow" x="47" y="20" width="134" height="278" rx="32"/><rect class="device-body" x="42" y="14" width="134" height="278" rx="32"/><rect class="device-camera-deck device-camera-deck--nord" x="55" y="31" width="48" height="91" rx="17"/><circle class="device-lens-ring" cx="70" cy="50" r="13"/><circle class="device-lens" cx="70" cy="50" r="9"/><circle class="device-lens-ring" cx="88" cy="80" r="13"/><circle class="device-lens" cx="88" cy="80" r="9"/><circle class="device-lens-ring" cx="70" cy="105" r="8"/><circle class="device-lens" cx="70" cy="105" r="5"/><circle class="device-flash" cx="90" cy="106" r="5"/><text class="device-g-mark device-g-mark--small" x="90" y="205">1+</text></g></svg>',
    oneplus:
      '<svg class="imed-device-render imed-device-render--oneplus" viewBox="0 0 220 320" fill="none"><g transform="rotate(-4 110 160)"><rect class="device-shadow" x="47" y="20" width="134" height="278" rx="32"/><rect class="device-body" x="42" y="14" width="134" height="278" rx="32"/><circle class="device-camera-deck device-camera-deck--round" cx="89" cy="76" r="43"/><circle class="device-lens-ring" cx="74" cy="62" r="14"/><circle class="device-lens" cx="74" cy="62" r="10"/><circle class="device-lens-ring" cx="104" cy="62" r="14"/><circle class="device-lens" cx="104" cy="62" r="10"/><circle class="device-lens-ring" cx="74" cy="91" r="14"/><circle class="device-lens" cx="74" cy="91" r="10"/><circle class="device-flash" cx="104" cy="91" r="7"/><text class="device-g-mark device-g-mark--small" x="90" y="205">1+</text></g></svg>',
    'xiaomi-ultra':
      '<svg class="imed-device-render imed-device-render--xiaomi-ultra" viewBox="0 0 220 320" fill="none"><g transform="rotate(-4 110 160)"><rect class="device-shadow" x="47" y="20" width="134" height="278" rx="31"/><rect class="device-body" x="42" y="14" width="134" height="278" rx="31"/><rect class="device-edge" x="48" y="20" width="122" height="266" rx="26"/><circle class="device-camera-deck device-camera-deck--round" cx="92" cy="78" r="48"/><circle class="device-lens-ring" cx="74" cy="60" r="15"/><circle class="device-lens" cx="74" cy="60" r="10"/><circle class="device-lens-ring" cx="110" cy="60" r="15"/><circle class="device-lens" cx="110" cy="60" r="10"/><circle class="device-lens-ring" cx="74" cy="96" r="15"/><circle class="device-lens" cx="74" cy="96" r="10"/><circle class="device-lens-ring device-lens-ring--small" cx="110" cy="96" r="11"/><circle class="device-lens" cx="110" cy="96" r="7"/><circle class="device-flash" cx="92" cy="78" r="6"/><text class="device-wordmark" x="78" y="255">LEICA</text></g><g class="device-front-preview" transform="rotate(4 110 160)"><rect class="device-screen-body" x="112" y="54" width="72" height="220" rx="24"/><rect class="device-screen" x="117" y="60" width="62" height="208" rx="19"/><circle class="device-punch" cx="148" cy="72" r="4"/></g></svg>',
    xiaomi:
      '<svg class="imed-device-render imed-device-render--xiaomi" viewBox="0 0 220 320" fill="none"><g transform="rotate(-4 110 160)"><rect class="device-shadow" x="47" y="20" width="134" height="278" rx="31"/><rect class="device-body" x="42" y="14" width="134" height="278" rx="31"/><rect class="device-edge" x="48" y="20" width="122" height="266" rx="26"/><rect class="device-camera-deck" x="55" y="31" width="84" height="91" rx="20"/><circle class="device-lens-ring" cx="78" cy="57" r="17"/><circle class="device-lens" cx="78" cy="57" r="12"/><circle class="device-lens-ring" cx="114" cy="57" r="17"/><circle class="device-lens" cx="114" cy="57" r="12"/><circle class="device-lens-ring" cx="78" cy="94" r="17"/><circle class="device-lens" cx="78" cy="94" r="12"/><circle class="device-flash" cx="115" cy="94" r="7"/><text class="device-wordmark" x="82" y="255">XIAOMI</text></g><g class="device-front-preview" transform="rotate(4 110 160)"><rect class="device-screen-body" x="112" y="54" width="72" height="220" rx="24"/><rect class="device-screen" x="117" y="60" width="62" height="208" rx="19"/><circle class="device-punch" cx="148" cy="72" r="4"/></g></svg>',
    'xiaomi-flip':
      "<svg class=\"imed-device-render imed-device-render--xiaomi-flip\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-4 110 160)\"> <rect class=\"device-shadow\" x=\"52\" y=\"19\" width=\"124\" height=\"280\" rx=\"31\"/> <rect class=\"device-body\" x=\"47\" y=\"13\" width=\"124\" height=\"280\" rx=\"31\"/> <path class=\"device-fold\" d=\"M50 158h118\"/> <rect class=\"device-cover-screen\" x=\"60\" y=\"29\" width=\"78\" height=\"62\" rx=\"15\"/> <circle class=\"device-lens-ring\" cx=\"71\" cy=\"110\" r=\"13\"/><circle class=\"device-lens\" cx=\"71\" cy=\"110\" r=\"9\"/> <circle class=\"device-lens-ring\" cx=\"103\" cy=\"110\" r=\"13\"/><circle class=\"device-lens\" cx=\"103\" cy=\"110\" r=\"9\"/> </g></svg>",
    'ipad-pro':
      "<svg class=\"imed-device-render imed-device-render--ipad-pro\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-3 110 160)\"> <rect class=\"device-shadow\" x=\"25\" y=\"36\" width=\"176\" height=\"246\" rx=\"22\"/> <rect class=\"device-body\" x=\"20\" y=\"30\" width=\"176\" height=\"246\" rx=\"22\"/> <rect class=\"device-edge\" x=\"27\" y=\"37\" width=\"162\" height=\"232\" rx=\"17\"/> <rect class=\"device-camera-deck\" x=\"35\" y=\"46\" width=\"51\" height=\"51\" rx=\"15\"/> <circle class=\"device-lens-ring\" cx=\"50\" cy=\"61\" r=\"11\"/><circle class=\"device-lens\" cx=\"50\" cy=\"61\" r=\"7\"/> <circle class=\"device-lens-ring\" cx=\"70\" cy=\"81\" r=\"11\"/><circle class=\"device-lens\" cx=\"70\" cy=\"81\" r=\"7\"/> <circle class=\"device-flash\" cx=\"71\" cy=\"60\" r=\"5\"/> </g></svg>",
    ipad:
      "<svg class=\"imed-device-render imed-device-render--ipad\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-3 110 160)\"> <rect class=\"device-shadow\" x=\"25\" y=\"36\" width=\"176\" height=\"246\" rx=\"22\"/> <rect class=\"device-body\" x=\"20\" y=\"30\" width=\"176\" height=\"246\" rx=\"22\"/> <rect class=\"device-edge\" x=\"27\" y=\"37\" width=\"162\" height=\"232\" rx=\"17\"/> <rect class=\"device-camera-deck\" x=\"35\" y=\"46\" width=\"51\" height=\"51\" rx=\"15\"/> <circle class=\"device-lens-ring\" cx=\"50\" cy=\"61\" r=\"11\"/><circle class=\"device-lens\" cx=\"50\" cy=\"61\" r=\"7\"/> <circle class=\"device-lens-ring\" cx=\"70\" cy=\"81\" r=\"11\"/><circle class=\"device-lens\" cx=\"70\" cy=\"81\" r=\"7\"/> <circle class=\"device-flash\" cx=\"71\" cy=\"60\" r=\"5\"/> </g></svg>",
    'galaxy-tab':
      "<svg class=\"imed-device-render imed-device-render--galaxy-tab\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-3 110 160)\"> <rect class=\"device-shadow\" x=\"25\" y=\"36\" width=\"176\" height=\"246\" rx=\"22\"/> <rect class=\"device-body\" x=\"20\" y=\"30\" width=\"176\" height=\"246\" rx=\"22\"/> <rect class=\"device-edge\" x=\"27\" y=\"37\" width=\"162\" height=\"232\" rx=\"17\"/> <rect class=\"device-camera-deck\" x=\"35\" y=\"46\" width=\"51\" height=\"51\" rx=\"15\"/> <circle class=\"device-lens-ring\" cx=\"50\" cy=\"61\" r=\"11\"/><circle class=\"device-lens\" cx=\"50\" cy=\"61\" r=\"7\"/> <circle class=\"device-lens-ring\" cx=\"70\" cy=\"81\" r=\"11\"/><circle class=\"device-lens\" cx=\"70\" cy=\"81\" r=\"7\"/> <circle class=\"device-flash\" cx=\"71\" cy=\"60\" r=\"5\"/> </g></svg>",
    macbook:
      '<svg class="imed-device-render imed-device-render--macbook" viewBox="0 0 220 320" fill="none"><rect class="device-shadow" x="27" y="54" width="172" height="126" rx="10"/><rect class="device-body" x="22" y="48" width="172" height="126" rx="10"/><rect class="device-screen" x="31" y="58" width="154" height="106" rx="5"/><path class="device-laptop-base" d="M8 184h200l-17 42H25z"/><path class="device-highlight" d="M33 59h151"/><path class="device-logo" d="M108 92c6-7 14-5 17-2-8 5-7 15 1 19-3 9-8 17-15 17-5 0-7-3-12-3s-8 3-12 3c-7 0-15-11-15-22s7-17 15-17c5 0 9 3 12 3 2 0 6-3 9-5z"/></svg>',
    'laptop-microsoft':
      '<svg class="imed-device-render imed-device-render--laptop-microsoft" viewBox="0 0 220 320" fill="none"><rect class="device-shadow" x="27" y="54" width="172" height="126" rx="8"/><rect class="device-body" x="22" y="48" width="172" height="126" rx="8"/><rect class="device-screen" x="31" y="58" width="154" height="106" rx="4"/><path class="device-laptop-base" d="M8 184h200l-17 42H25z"/><g class="device-logo"><rect x="91" y="98" width="15" height="15"/><rect x="109" y="98" width="15" height="15"/><rect x="91" y="116" width="15" height="15"/><rect x="109" y="116" width="15" height="15"/></g></svg>',
    'laptop-lenovo':
      '<svg class="imed-device-render imed-device-render--laptop-lenovo" viewBox="0 0 220 320" fill="none"><rect class="device-shadow" x="27" y="54" width="172" height="126" rx="7"/><rect class="device-body" x="22" y="48" width="172" height="126" rx="7"/><rect class="device-screen" x="31" y="58" width="154" height="106" rx="3"/><path class="device-laptop-base" d="M8 184h200l-17 42H25z"/><text class="device-wordmark" x="76" y="122">ThinkPad</text><circle class="device-flash" cx="138" cy="107" r="4"/></svg>',
    'laptop-dell':
      '<svg class="imed-device-render imed-device-render--laptop-dell" viewBox="0 0 220 320" fill="none"><rect class="device-shadow" x="27" y="54" width="172" height="126" rx="9"/><rect class="device-body" x="22" y="48" width="172" height="126" rx="9"/><rect class="device-screen" x="31" y="58" width="154" height="106" rx="4"/><path class="device-laptop-base" d="M8 184h200l-17 42H25z"/><circle class="device-logo" cx="108" cy="113" r="23"/><text class="device-wordmark" x="88" y="120">DELL</text></svg>',
    'laptop-asus':
      '<svg class="imed-device-render imed-device-render--laptop-asus" viewBox="0 0 220 320" fill="none"><rect class="device-shadow" x="27" y="54" width="172" height="126" rx="8"/><rect class="device-body" x="22" y="48" width="172" height="126" rx="8"/><rect class="device-screen" x="31" y="58" width="154" height="106" rx="4"/><path class="device-laptop-base" d="M8 184h200l-17 42H25z"/><text class="device-wordmark" x="80" y="121">ASUS</text></svg>',
    'laptop-hp':
      '<svg class="imed-device-render imed-device-render--laptop-hp" viewBox="0 0 220 320" fill="none"><rect class="device-shadow" x="27" y="54" width="172" height="126" rx="10"/><rect class="device-body" x="22" y="48" width="172" height="126" rx="10"/><rect class="device-screen" x="31" y="58" width="154" height="106" rx="5"/><path class="device-laptop-base" d="M8 184h200l-17 42H25z"/><circle class="device-logo" cx="108" cy="113" r="24"/><text class="device-wordmark" x="94" y="122">hp</text></svg>',
    smartwatch:
      '<svg class="imed-device-render imed-device-render--smartwatch" viewBox="0 0 220 320" fill="none"><rect class="device-watch-band" x="79" y="7" width="62" height="90" rx="25"/><rect class="device-watch-band" x="79" y="223" width="62" height="90" rx="25"/><rect class="device-shadow" x="47" y="73" width="126" height="176" rx="40"/><rect class="device-body" x="42" y="67" width="126" height="176" rx="40"/><rect class="device-screen" x="53" y="79" width="104" height="152" rx="31"/><circle class="device-crown" cx="174" cy="123" r="10"/><circle class="device-watch-face" cx="105" cy="155" r="43"/><path class="device-watch-hand" d="M105 155v-29M105 155l25 18"/></svg>',
    console:
      "<svg class=\"imed-device-render imed-device-render--console\" viewBox=\"0 0 220 320\" fill=\"none\"><path class=\"device-shadow\" d=\"M34 102c12-29 39-38 76-20 37-18 64-9 76 20l20 83c8 34-27 48-45 20l-22-31H81l-22 31c-18 28-53 14-45-20z\"/><path class=\"device-body\" d=\"M29 96c12-29 39-38 76-20 37-18 64-9 76 20l20 83c8 34-27 48-45 20l-22-31H76l-22 31c-18 28-53 14-45-20z\"/><circle class=\"device-control\" cx=\"70\" cy=\"122\" r=\"18\"/><circle class=\"device-control\" cx=\"147\" cy=\"142\" r=\"18\"/><path class=\"device-dpad\" d=\"M49 150h14v-14h14v14h14v14H77v14H63v-14H49z\"/><circle class=\"device-button\" cx=\"168\" cy=\"107\" r=\"6\"/><circle class=\"device-button\" cx=\"184\" cy=\"122\" r=\"6\"/><circle class=\"device-button\" cx=\"152\" cy=\"122\" r=\"6\"/><circle class=\"device-button\" cx=\"168\" cy=\"138\" r=\"6\"/></svg>",
    'thermomix-tm5':
      '<svg class="imed-device-render imed-device-render--thermomix-tm5" viewBox="0 0 220 320" fill="none"><path class="device-shadow" d="M67 35h84l17 45-14 96H61L48 80z"/><path class="device-body" d="M62 29h84l17 45-14 96H56L43 74z"/><rect class="device-handle" x="145" y="51" width="31" height="92" rx="15"/><rect class="device-screen" x="69" y="185" width="68" height="45" rx="6"/><circle class="device-control" cx="151" cy="207" r="16"/><path class="device-stand" d="M52 242h112l22 50H31z"/><text class="device-wordmark" x="84" y="271">TM5</text></svg>',
    'thermomix-tm6':
      '<svg class="imed-device-render imed-device-render--thermomix-tm6" viewBox="0 0 220 320" fill="none"><path class="device-shadow" d="M68 35h84l17 46-13 88H64L51 81z"/><path class="device-body" d="M63 29h84l17 46-13 88H59L46 75z"/><rect class="device-handle" x="146" y="53" width="28" height="86" rx="14"/><rect class="device-screen" x="58" y="180" width="105" height="65" rx="13"/><circle class="device-control" cx="145" cy="212" r="18"/><path class="device-stand" d="M54 250h112l21 44H33z"/><text class="device-wordmark" x="84" y="275">TM6</text></svg>',
    'thermomix-tm7':
      '<svg class="imed-device-render imed-device-render--thermomix-tm7" viewBox="0 0 220 320" fill="none"><path class="device-shadow" d="M70 42h81l15 42-12 82H66L53 84z"/><path class="device-body" d="M65 36h81l15 42-12 82H61L48 78z"/><rect class="device-handle" x="145" y="57" width="27" height="83" rx="14"/><path class="device-stand" d="M42 169h136l14 121H28z"/><rect class="device-screen" x="43" y="181" width="134" height="88" rx="17"/><circle class="device-control" cx="155" cy="227" r="16"/><text class="device-wordmark" x="87" y="285">TM7</text></svg>',
    'generic-tablet':
      "<svg class=\"imed-device-render imed-device-render--generic-tablet\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-3 110 160)\"> <rect class=\"device-shadow\" x=\"25\" y=\"36\" width=\"176\" height=\"246\" rx=\"22\"/> <rect class=\"device-body\" x=\"20\" y=\"30\" width=\"176\" height=\"246\" rx=\"22\"/> <rect class=\"device-edge\" x=\"27\" y=\"37\" width=\"162\" height=\"232\" rx=\"17\"/> <rect class=\"device-camera-deck\" x=\"35\" y=\"46\" width=\"51\" height=\"51\" rx=\"15\"/> <circle class=\"device-lens-ring\" cx=\"50\" cy=\"61\" r=\"11\"/><circle class=\"device-lens\" cx=\"50\" cy=\"61\" r=\"7\"/> <circle class=\"device-lens-ring\" cx=\"70\" cy=\"81\" r=\"11\"/><circle class=\"device-lens\" cx=\"70\" cy=\"81\" r=\"7\"/> <circle class=\"device-flash\" cx=\"71\" cy=\"60\" r=\"5\"/> </g></svg>",
    'generic-smartphone':
      "<svg class=\"imed-device-render imed-device-render--generic-smartphone\" viewBox=\"0 0 220 320\" fill=\"none\"><g transform=\"rotate(-4 110 160)\"> <rect class=\"device-shadow\" x=\"47\" y=\"20\" width=\"134\" height=\"278\" rx=\"32\"/> <rect class=\"device-body\" x=\"42\" y=\"14\" width=\"134\" height=\"278\" rx=\"32\"/> <rect class=\"device-camera-deck\" x=\"55\" y=\"31\" width=\"62\" height=\"67\" rx=\"20\"/> <circle class=\"device-lens-ring\" cx=\"75\" cy=\"51\" r=\"15\"/><circle class=\"device-lens\" cx=\"75\" cy=\"51\" r=\"10\"/> <circle class=\"device-lens-ring\" cx=\"99\" cy=\"76\" r=\"15\"/><circle class=\"device-lens\" cx=\"99\" cy=\"76\" r=\"10\"/> <circle class=\"device-flash\" cx=\"99\" cy=\"49\" r=\"6\"/> <path class=\"device-highlight\" d=\"M61 27c-9 5-14 14-14 29v183\"/> </g></svg>",
  };

  function getSilhouetteSvg(key) {
    return DEVICE_SILHOUETTES[key] || DEVICE_SILHOUETTES['generic-smartphone'];
  }

  function slugify(value) {
    return (value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function detectBrand(product) {
    const title = (product.title || '').toLowerCase();
    const type = (product.product_type || product.type || '').toLowerCase();
    const vendor = (product.vendor || '').toLowerCase();
    let slug = slugify(product.vendor || '');
    let name = product.vendor || '';

    if (title.includes('xbox')) {
      slug = 'xbox';
      name = 'Xbox';
    } else if (title.includes('playstation') || title.includes('ps5') || title.includes('ps4')) {
      slug = 'sony';
      name = 'Sony';
    } else if (title.includes('switch') || title.includes('nintendo')) {
      slug = 'nintendo';
      name = 'Nintendo';
    } else if (
      title.includes('oneplus') ||
      title.includes('one plus') ||
      vendor.includes('oneplus') ||
      vendor.includes('one plus')
    ) {
      slug = 'oneplus';
      name = 'OnePlus';
    } else if (!slug || slug === 'imed-mobile' || slug === 'imed') {
      if (title.includes('iphone') || title.includes('ipad') || title.includes('macbook') || type.includes('iphone')) {
        slug = 'apple';
        name = 'Apple';
      } else if (title.includes('galaxy') || title.includes('samsung')) {
        slug = 'samsung';
        name = 'Samsung';
      } else if (title.includes('pixel') || title.includes('google')) {
        slug = 'google';
        name = 'Google';
      } else if (title.includes('oneplus')) {
        slug = 'oneplus';
        name = 'OnePlus';
      } else if (title.includes('xiaomi') || title.includes('redmi') || title.includes('poco')) {
        slug = 'xiaomi';
        name = 'Xiaomi';
      } else if (title.includes('huawei')) {
        slug = 'huawei';
        name = 'Huawei';
      } else if (title.includes('oppo')) {
        slug = 'oppo';
        name = 'OPPO';
      } else if (title.includes('motorola') || title.includes('moto ')) {
        slug = 'motorola';
        name = 'Motorola';
      } else if (title.includes('thermomix') || vendor.includes('vorwerk')) {
        slug = 'vorwerk';
        name = 'Vorwerk';
      } else {
        slug = 'default';
        name = 'iMed';
      }
    }

    return {
      slug,
      name,
      color: BRAND_COLORS[slug] || BRAND_COLORS.default,
    };
  }

  function detectRepairIcon(repairLabel) {
    const slug = slugify(repairLabel || '');
    if (slug.includes('waage')) return 'scale';
    if (slug.includes('verriegel')) return 'lock';
    if (slug.includes('heizung') || slug.includes('temperatur')) return 'heat';
    if (slug.includes('motor')) return 'motor';
    if (slug.includes('display') || slug.includes('bildschirm') || slug.includes('displayglas') || slug.includes('oled')) {
      return 'display';
    }
    if (slug.includes('akku') || slug.includes('batterie')) return 'battery';
    if (slug.includes('kamera') || slug.includes('camera')) return 'camera';
    if (slug.includes('backcover') || slug.includes('ruckseite') || slug.includes('rueckseite') || slug.includes('gehause') || slug.includes('rahmen')) {
      return 'back';
    }
    if (slug.includes('ladebuchse') || slug.includes('ladeport') || slug.includes('laden')) return 'charging';
    if (slug.includes('diagnose') || slug.includes('kostenvoranschlag')) return 'diagnose';
    if (slug.includes('wasserschaden') || slug.includes('wasser')) return 'water';
    if (slug.includes('mikrofon') || slug.includes('lautsprecher') || slug.includes('audio')) return 'audio';
    if (slug.includes('glas') || slug.includes('glass')) return 'glass';
    return 'repair';
  }

  function detectSilhouetteKey(product) {
    const tags = Array.isArray(product.tags)
      ? product.tags.join(' ')
      : (product.tags || '');
    const modelSource = `${product.product_type || product.type || ''} ${product.title || ''} ${tags}`.toLowerCase();

    if (modelSource.includes('z fold') || modelSource.includes('galaxy z fold')) return 'galaxy-z-fold';
    if (modelSource.includes('pro fold') || modelSource.includes('pixel fold')) return 'pixel-fold';
    if (modelSource.includes('z flip') || modelSource.includes('galaxy z flip')) return 'galaxy-z-flip';
    if (modelSource.includes('mix flip')) return 'xiaomi-flip';
    if (modelSource.includes('galaxy tab') || modelSource.includes('tab s') || modelSource.includes('tab a')) {
      return 'galaxy-tab';
    }
    if (modelSource.includes('ipad pro')) return 'ipad-pro';
    if (modelSource.includes('ipad')) return 'ipad';
    if (modelSource.includes('macbook')) return 'macbook';
    if (modelSource.includes('surface')) return 'laptop-microsoft';
    if (modelSource.includes('thinkpad') || modelSource.includes('ideapad') || modelSource.includes('thinkbook')) {
      return 'laptop-lenovo';
    }
    if (
      modelSource.includes('latitude') ||
      modelSource.includes('inspiron') ||
      modelSource.includes('precision') ||
      /\bxps\b/.test(modelSource)
    ) {
      return 'laptop-dell';
    }
    if (
      modelSource.includes('zenbook') ||
      modelSource.includes('vivobook') ||
      modelSource.includes('expertbook') ||
      modelSource.includes('rog ') ||
      modelSource.includes('tuf ')
    ) {
      return 'laptop-asus';
    }
    if (
      modelSource.includes('elitebook') ||
      modelSource.includes('probook') ||
      modelSource.includes('spectre') ||
      modelSource.includes('pavilion') ||
      modelSource.includes('envy')
    ) {
      return 'laptop-hp';
    }
    if (modelSource.includes('apple watch') || modelSource.includes('galaxy watch') || modelSource.includes(' watch')) {
      return 'smartwatch';
    }
    if (modelSource.includes('iphone 17 air') || modelSource.includes('iphone air')) return 'iphone-air';
    if (modelSource.includes('iphone 17 pro')) return 'iphone-17-pro';
    if (
      modelSource.includes('iphone 16 pro') ||
      modelSource.includes('iphone 15 pro') ||
      modelSource.includes('iphone 14 pro') ||
      modelSource.includes('iphone 13 pro') ||
      modelSource.includes('iphone 12 pro')
    ) {
      return 'iphone-16-pro';
    }
    if (modelSource.includes('iphone 16') || modelSource.includes('iphone 17') || modelSource.includes('iphone 15')) {
      return 'iphone-15';
    }
    if (modelSource.includes('iphone 14') || modelSource.includes('iphone 13') || modelSource.includes('iphone 12')) {
      return 'iphone-14';
    }
    if (
      modelSource.includes('iphone se') ||
      modelSource.includes('iphone 11') ||
      modelSource.includes('iphone x') ||
      modelSource.includes('iphone 8') ||
      modelSource.includes('iphone 7') ||
      modelSource.includes('iphone 6')
    ) {
      return 'iphone-legacy';
    }
    if (modelSource.includes('iphone')) return 'iphone-15';
    if (
      /s(20|21|22|23|24|25|26) ultra|galaxy note|note 20|note 10|note9|note 9/.test(modelSource)
    ) {
      return 'galaxy-s-ultra';
    }
    if (modelSource.includes('galaxy s') || /galaxy s[0-9]/.test(modelSource)) return 'galaxy-s';
    if (modelSource.includes('galaxy a')) return 'galaxy-a';
    if (modelSource.includes('pixel')) return 'pixel-bar';
    if (modelSource.includes('oneplus nord') || modelSource.includes('one plus nord')) {
      return 'oneplus-nord';
    }
    if (modelSource.includes('oneplus') || modelSource.includes('one plus')) return 'oneplus';
    if (modelSource.includes('mix fold')) return 'xiaomi-ultra';
    if (
      modelSource.includes('11 ultra') ||
      modelSource.includes('12 ultra') ||
      modelSource.includes('13 ultra') ||
      modelSource.includes('14 ultra') ||
      modelSource.includes('15 ultra') ||
      modelSource.includes('mi ultra') ||
      modelSource.includes('xiaomi ultra') ||
      modelSource.includes('redmi ultra')
    ) {
      return 'xiaomi-ultra';
    }
    if (
      modelSource.includes('xiaomi') ||
      modelSource.includes('redmi') ||
      modelSource.includes('poco') ||
      modelSource.includes('mi mix') ||
      modelSource.includes('xiaomi mix')
    ) {
      return 'xiaomi';
    }
    if (modelSource.includes('playstation') || modelSource.includes('ps5') || modelSource.includes('ps4')) {
      return 'console';
    }
    if (modelSource.includes('xbox')) return 'console';
    if (modelSource.includes('switch') || modelSource.includes('nintendo')) return 'console';
    if (modelSource.includes('thermomix tm5') || modelSource.includes(' tm5')) return 'thermomix-tm5';
    if (modelSource.includes('thermomix tm7') || modelSource.includes(' tm7')) return 'thermomix-tm7';
    if (modelSource.includes('thermomix tm6') || modelSource.includes(' tm6')) return 'thermomix-tm6';
    if (modelSource.includes('thermomix')) return 'thermomix-tm6';
    if (modelSource.includes('tablet') || modelSource.includes('tab ')) return 'generic-tablet';
    if (modelSource.includes('laptop')) return 'laptop-microsoft';
    return 'generic-smartphone';
  }

  function getBrandLogoUrl(slug) {
    const base = window.IMED_DEVICE_BRAND_BASE || '';
    const fileSlug = BRAND_COLORS[slug] ? slug : 'default';
    return `${base}${fileSlug}.svg`;
  }

  function getCardServiceFallbackHtml(product) {
    /* Service text cards removed from product UX — prefer device preview */
    return getCardDeviceFallbackHtml(product);
  }

  function getCardDeviceFallbackHtml(product) {
    const silhouetteKey = detectSilhouetteKey(product);
    const silhouetteSvg = getSilhouetteSvg(silhouetteKey);
    return `<div class="imed-card-device-preview imed-card-device-preview--${silhouetteKey}" data-imed-device-preview="true" data-imed-silhouette="${silhouetteKey}" aria-hidden="true">${silhouetteSvg}</div>`;
  }

    function getRepairTicketHtml(product, collectionHandle, variant = 'mini') {
    const category = detectPlaceholderCategory(product, collectionHandle);
    const brand = detectBrand(product);
    const silhouetteKey = detectSilhouetteKey(product);
    const split = splitTitleIntoModelAndRepair(product.title || '');
    const modelName = product.product_type || product.type || split.model || product.title || '';
    const repairLabel = split.repair || product.title || '';
    const repairIcon = detectRepairIcon(repairLabel);
    const categoryLabel = CATEGORY_LABELS[category] || CATEGORY_LABELS.default;
    const logoUrl = getBrandLogoUrl(brand.slug);
    const silhouetteSvg = getSilhouetteSvg(silhouetteKey);
    const safeModel = (modelName || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const safeRepair = (repairLabel || '').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    const safeBrand = (brand.name || '').replace(/"/g, '&quot;');

    return `<div class="imed-repair-ticket imed-repair-ticket--${variant} imed-repair-ticket--${category} imed-repair-ticket--brand-${brand.slug} imed-repair-ticket--sil-${silhouetteKey}" style="--ticket-brand:${brand.color};" aria-hidden="true">
      <div class="imed-repair-ticket__panel">
        <div class="imed-repair-ticket__logo-pill">
          <img class="imed-repair-ticket__logo-mark" src="${logoUrl}" onload="this.hidden=false;this.nextElementSibling.hidden=true;" onerror="this.remove();" alt="${safeBrand}" width="24" height="24" loading="lazy" hidden>
          <span class="imed-repair-ticket__logo-text">${safeBrand}</span>
        </div>
        <div class="imed-repair-ticket__device-art imed-repair-ticket__device-art--${silhouetteKey}">${silhouetteSvg}</div>
        <div class="imed-repair-ticket__icon-wrap"><div class="imed-repair-ticket__icon">${REPAIR_ICONS[repairIcon] || REPAIR_ICONS.repair}</div></div>
        <p class="imed-repair-ticket__repair">${safeRepair}</p>
      </div>
      <div class="imed-repair-ticket__body">
        <div class="imed-repair-ticket__body-meta">
          <p class="imed-repair-ticket__model">${safeModel}</p>
          <span class="imed-repair-ticket__chip">${categoryLabel}</span>
        </div>
      </div>
    </div>`;
  }

  const PLACEHOLDER_SVGS = {
    tablet:
      '<svg class="imed-product-placeholder__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"><rect x="88" y="96" width="224" height="208" rx="18" fill="currentColor"/><rect x="104" y="112" width="192" height="168" rx="8" fill="#fff"/><circle cx="200" cy="292" r="7" fill="#fff"/></svg>',
    laptop:
      '<svg class="imed-product-placeholder__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"><rect x="92" y="108" width="216" height="136" rx="10" fill="currentColor"/><rect x="104" y="120" width="192" height="108" rx="4" fill="#fff"/><path d="M72 256h256l-20 24H92z" fill="currentColor" opacity="0.7"/><rect x="72" y="248" width="256" height="12" rx="4" fill="currentColor"/></svg>',
    console:
      '<svg class="imed-product-placeholder__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"><rect x="96" y="148" width="208" height="104" rx="28" fill="currentColor"/><circle cx="148" cy="200" r="16" fill="#fff"/><circle cx="252" cy="184" r="10" fill="#fff"/><circle cx="276" cy="208" r="10" fill="#fff"/><circle cx="252" cy="232" r="10" fill="#fff"/><circle cx="228" cy="208" r="10" fill="#fff"/></svg>',
    thermomix:
      '<svg class="imed-product-placeholder__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"><path d="M128 248c0-44 32-80 72-80s72 36 72 80" fill="none" stroke="currentColor" stroke-width="18" stroke-linecap="round"/><rect x="176" y="88" width="48" height="72" rx="8" fill="currentColor"/><rect x="188" y="72" width="24" height="24" rx="6" fill="#fff"/></svg>',
    escooter:
      '<svg class="imed-product-placeholder__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"><rect x="176" y="96" width="16" height="128" rx="8" fill="currentColor"/><rect x="160" y="88" width="48" height="16" rx="8" fill="currentColor"/><circle cx="168" cy="272" r="28" fill="none" stroke="currentColor" stroke-width="14"/><circle cx="248" cy="272" r="28" fill="none" stroke="currentColor" stroke-width="14"/><path d="M184 224h56l24 32" fill="none" stroke="currentColor" stroke-width="12" stroke-linecap="round"/></svg>',
    smartwatch:
      '<svg class="imed-product-placeholder__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"><rect x="168" y="88" width="64" height="36" rx="12" fill="currentColor"/><rect x="168" y="276" width="64" height="36" rx="12" fill="currentColor"/><rect x="152" y="124" width="96" height="152" rx="28" fill="currentColor"/><rect x="168" y="148" width="64" height="104" rx="18" fill="#fff"/><line x1="200" y1="168" x2="200" y2="208" stroke="currentColor" stroke-width="6" stroke-linecap="round"/><line x1="200" y1="208" x2="224" y2="224" stroke="currentColor" stroke-width="6" stroke-linecap="round"/></svg>',
    smartphone:
      '<svg class="imed-product-placeholder__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"><rect x="138" y="72" width="124" height="256" rx="22" fill="currentColor"/><rect x="152" y="96" width="96" height="188" rx="6" fill="#fff"/><circle cx="200" cy="300" r="8" fill="#fff"/><rect x="168" y="84" width="64" height="8" rx="4" fill="currentColor" opacity="0.55"/></svg>',
    default:
      '<svg class="imed-product-placeholder__svg" viewBox="0 0 400 400" xmlns="http://www.w3.org/2000/svg"><rect x="120" y="120" width="160" height="160" rx="24" fill="none" stroke="currentColor" stroke-width="10"/><path d="M176 200h48M200 176v48" stroke="currentColor" stroke-width="12" stroke-linecap="round"/></svg>',
  };

  function isPlaceholderProductImage(imageSrc) {
    if (!imageSrc) return true;
    return imageSrc.includes(PLACEHOLDER_IMAGE_HASH);
  }

  function getPlaceholderSvgHtml(category) {
    const svg = PLACEHOLDER_SVGS[category] || PLACEHOLDER_SVGS.default;
    return `<div class="imed-product-placeholder imed-product-placeholder--${category}" aria-hidden="true" style="color:#f5f5f7">${svg}</div>`;
  }

  function getProductImageSrc(product) {
    if (!product) return null;

    const firstImage = product.images?.[0];
    if (typeof firstImage === 'string' && firstImage) return firstImage;
    if (firstImage?.src) return firstImage.src;

    if (product.image?.src) return product.image.src;
    if (typeof product.image === 'string' && product.image) return product.image;
    if (typeof product.featured_image === 'string' && product.featured_image) return product.featured_image;
    if (product.featured_image?.src) return product.featured_image.src;

    return null;
  }

  function getProductImageHtml(product, collectionHandle) {
    const alt = (product.title || '').replace(/"/g, '&quot;');
    const imageSrc = getProductImageSrc(product);
    const category = detectPlaceholderCategory(product, collectionHandle);

    if (imageSrc && !isPlaceholderProductImage(imageSrc)) {
      return `<img src="${imageSrc}" alt="${alt}" class="imed-konfigurator__result-photo" loading="lazy" width="400" height="400" style="object-fit:contain;object-position:center bottom;max-height:160px;width:auto;">`;
    }

    return getRepairTicketHtml(product, collectionHandle, 'mini');
  }

  function purgeLegacySessionCaches() {
    try {
      for (let i = sessionStorage.length - 1; i >= 0; i -= 1) {
        const key = sessionStorage.key(i);
        if (key && key.startsWith('imed-col-')) {
          if (!key.startsWith(SESSION_PREFIX)) {
            sessionStorage.removeItem(key);
          }
        }
      }
    } catch {
      // ignore
    }
  }

  purgeLegacySessionCaches();

  window.ImedRepairCatalog = {
    cacheVersion: CACHE_VERSION,
    splitTitleIntoModelAndRepair,
    canonicalModelKey,
    mergeCatalogModels,
    isEscooterProduct,
    parseProduct,
    buildCatalog,
    filterModelNames,
    getUniqueModelNames,
    fetchCollection,
    refreshCollection,
    prefetchCollections,
    hideEmptyCategoryButtons,
    collectionHasProducts,
    formatMoney,
    getLowestVariantPrice,
    getUsableVariants,
    analyzeVariantPicker,
    VariantPickerUI,
    getProductImageHtml,
    detectPlaceholderCategory,
    isPlaceholderProductImage,
    getPlaceholderSvgHtml,
    getRepairTicketHtml,
    getCardDeviceFallbackHtml,
    getCardServiceFallbackHtml,
    detectBrand,
    detectSilhouetteKey,
  };
})();
